import React from 'react';
import SellerDetail from 'components/Tvendo/Sale/DataMaster/Seller/Details/SellerDetail';

export default function () {
  return <SellerDetail />;
}
